<template>
    <div class="bg">
        <div class="uk-background-default">
            <h1>Oops! Okay if your seeing this page don't worry.</h1> 
            <h1>You most likely have been automatically signed out.</h1>
            <router-link class="uk-text-large uk-text-primary " to="/login">click this to login in</router-link>
            <loader-icon></loader-icon>
            <h3>Or you could also just watch this if you really wanted</h3>
            <div class="background">
                <!-- <img src="https://s3.amazonaws.com/wageup-media/404.jpg"/> -->
            </div>
            
        </div>
        <!-- <a href="https://www.freepik.com/free-photos-vectors/background">Background vector created by freepik - www.freepik.com</a> -->
        </div>
</template>

<script>
    import spinnerOverlay from "./Spinner.vue"
    export default {
        name: "404",
        components: {
            loaderIcon:spinnerOverlay
        }
    }
</script>

<style lang="less" scoped>
.background {
    min-height: 60vh;
    width: 100%;
    background-image: url("https://s3.amazonaws.com/wageup-media/404.jpg");
    background-size: cover;
}

.bg {
  /* The image used */

  /* Full height */
  height: 100%;
  overflow-y: hidden;

  /* Center and scale the image nicely */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
</style>
